import { gsap } from "gsap";
import { lenis } from "./scroll";

import CarouselHandler from "./carousel";

export default class MapHandler {
	init() {
		gsap.utils.toArray('.acf-map').forEach((el) => {
			var markers = el.querySelectorAll('.marker');
			var mapArgs = {
				zoom: 16,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				zoomControl: false,
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				rotateControl: false,
				scrollwheel: false,
				draggable: false,
				styles: [
				  {
					"stylers": [
					  {
						"color": "#f5f0f0"
					  }
					]
				  },
				  {
					"elementType": "labels",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  },
				  {
					"featureType": "administrative",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  },
				  {
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
					  {
						"color": "#a8b1e9"
					  }
					]
				  },
				  {
					"featureType": "poi",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  },
				  {
					"featureType": "road",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  },
				  {
					"featureType": "transit",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  },
				  {
					"featureType": "water",
					"elementType": "labels.text",
					"stylers": [
					  {
						"visibility": "off"
					  }
					]
				  }
				]
			};
			var map = new google.maps.Map(el, mapArgs);
	
			map.markers = [];
			markers.forEach(function(marker) {
				initMarker(marker, map);
			});
	
			centerMap(map);
			return map;
		});

		var activeMarker = null;
		
		function initMarker(markerEl, map) {
			var lat = parseFloat(markerEl.dataset.lat);
			var lng = parseFloat(markerEl.dataset.lng);
			var latLng = { lat, lng };
		
			var defaultColor = "#242638";
			var activeColor = "#F05940";
		
			function createMarkerIcon(fillColor) {
				const svgIcon = `
					<svg width="32" height="32" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M19.2211 11.2276C19.2211 13.8632 17.1056 16.0031 14.5 16.0031C11.8945 16.0031 9.77892 13.8632 9.77892 11.2276C9.77892 8.59202 11.8945 6.45209 14.5 6.45209C17.1056 6.45209 19.2211 8.59202 19.2211 11.2276ZM24.6111 11.2276C24.6111 5.58668 20.0767 1 14.5 1C8.92336 1 4.38892 5.58668 4.38892 11.2276C4.38892 13.5485 6.00669 17.2147 9.20336 22.116C11.5445 25.7114 13.9167 28.6932 13.94 28.7246C14.08 28.8977 14.2822 29 14.5 29C14.7178 29 14.9278 28.8977 15.06 28.7246C15.0834 28.6932 17.4556 25.7036 19.7967 22.116C22.9934 17.2068 24.6111 13.5485 24.6111 11.2276Z" fill="${fillColor}"/>
					</svg>`;
		
				return {
					url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svgIcon),
					scaledSize: new google.maps.Size(32, 32),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(16, 32)
				};
			}
		
			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
				title: markerEl.dataset.title,
				icon: createMarkerIcon(defaultColor)
			});
		
			map.markers.push(marker);
			
			if (map.markers.length === 1) {
				activeMarker = marker;
				activeMarker.setIcon(createMarkerIcon(activeColor));
			}
		
			marker.addListener("click", function () {
				if (activeMarker && activeMarker !== marker) {
					activeMarker.setIcon(createMarkerIcon(defaultColor));
				} else {
					map.markers[0].setIcon(createMarkerIcon(defaultColor));
				}
			
				activeMarker = marker;
				marker.setIcon(createMarkerIcon(activeColor));
			
				const markerTitle = marker.getTitle();
				const headerHeight = document.querySelector('header').offsetHeight;
				const targetAccordion = document.querySelector(`#${markerTitle.toLowerCase()}`);
				if (targetAccordion) {
					const isActive = targetAccordion.classList.contains('is-active');
				
					document.querySelectorAll('[data-accordion="container"]').forEach((accordion) => {
						if (accordion !== targetAccordion) {
							accordion.classList.remove('is-active');
							gsap.set(accordion, { height: accordion.querySelector('[data-accordion="trigger"]').offsetHeight });
						}
					});
				
					if (!isActive) {
						targetAccordion.classList.add('is-active');
						const trigger = targetAccordion.querySelector('[data-accordion="trigger"]');
						const content = targetAccordion.querySelector('[data-accordion="content"]');
						gsap.set(targetAccordion, { height: trigger.offsetHeight + content.scrollHeight });
					}
				}
				
				if (document.querySelector('[data-accordion-type="map"]')) {
					const targetId = `#${markerTitle.toLowerCase()}`;
					lenis.scrollTo(targetId, { offset: -headerHeight });
				}
			
				if (document.querySelector('[data-carousel-type="map"]')) {
					const slides = gsap.utils.toArray('[data-carousel="slide"]');
					const activeSlide = slides.find((slide) => slide.getAttribute('data-carousel-title') === markerTitle);
					
					slides.forEach((slide) => slide.classList.remove('is-active'));
					
					if (activeSlide) {
						activeSlide.classList.add('is-active');
						const index = slides.indexOf(activeSlide);
						const container = activeSlide.closest('[data-carousel="container"]');
						if (container) {
							const id = container.getAttribute('data-carousel-id');
							const carousel = CarouselHandler.carousels.get(id);
							if (carousel) {
								carousel.loop.toIndex(index, { duration: 1, ease: "power4.out" });
							}
						}
					}
				}
			});
		}

		function centerMap(map) {
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function(marker) {
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});
			if (map.markers.length === 1) {
				map.setCenter(bounds.getCenter());
			} else {
				map.fitBounds(bounds);
			}
		}
	}
}
